<template lang="pug">
b-field.event-form-field(
  :class="{ 'is-required': field.is_required, 'checkbox-label': field.type === 'checkbox', 'is-danger': type === 'is-danger' }"
  :label="(field.type === 'address' || field.type === 'checkbox' || field.type === 'waiver') ? '' : field.label"
  :expanded="expanded"
  :type="type"
  :message="message"
)
  b-input(
    v-if="field.type === 'text' || field.type === 'email'"
    type="text"
    :icon="field.type === 'email' ? 'email-outline' : ''"
    :name="field.name"
    :placeholder="field.placeholder"
    @input="inputHandler"
  )
  phone-field(
    v-else-if="field.type === 'phone_number'"
    :name="field.name"
    :placeholder="field.placeholder"
    @input="inputHandler"
  )
  b-input(
    v-else-if="field.type === 'textarea'"
    type="textarea"
    :value="field.value"
    :placeholder="field.placeholder"
    :rows="field.rows"
    :name="field.name"
    @input="inputHandler"
  )
  b-input(
    v-else-if="field.type === 'number'"
    type="number"
    :placeholder="field.placeholder"
    @input="inputHandler"
  )
  b-datepicker(
    v-else-if="field.type === 'date'"
    icon="calendar-blank"
    :value="field.value"
    @input="inputHandler"
  )
  b-select(
    v-else-if="field.type === 'select' && field.select_type === 'select'"
    :placeholder="field.placeholder"
    @input="optionInputHandler"
  )
    option(
      v-for="option in field.options"
      :key="option.id"
      :value="option.key"
    ) {{ option.label }}
  .select-checkboxes(v-else-if="field.type === 'select' && field.select_type === 'check'")
    b-field(
      v-for="option in field.options"
      :key="option.id"
    )
      b-checkbox(
        v-model="multi"
        :value="option.value"
        :native-value="option.label"
        :name="option.key"
        @input="inputHandler"
      ) {{ option.label }}
  b-checkbox(
    v-else-if="field.type === 'checkbox'"
    :value="field.value"
    :name="field.key"
    @input="inputHandler"
  )
    //- span(v-if="field.label === 'Terms'")
    //-   span(style="padding-right:0.3rem;") I agree to the
    //-   a() terms and conditions
    //- span(v-else-if="field.label === 'Medical'")
    //-   span(style="padding-right:0.3rem;") I agree to the terms of the
    //-   a() medical liability form
    span {{ field.label }}
  b-checkbox(
    v-else-if="field.type === 'waiver'"
    :value="field.value"
    :name="field.key"
    @input="inputHandler"
  )
    span I agree to the
      a(style="padding-left:0.25rem;" @click="openWaiver(field.waiver)") {{ field.waiver.name }}
  address-field(
    v-else-if="field.type === 'address'"
    :value="field.value"
    :required="field.is_required"
    :name="field.name"
    @input="inputHandler"
  )
</template>

<script>
import AddressField from '@/components/events/AddressField.vue';
//import MedicalLiability from '@/components/events/MedicalLiability.vue';
import PhoneField from '@/components/events/PhoneField.vue';
import WaiverModal from '@/components/events/WaiverModal.vue';
//import TermsAndConditions from '@/components/events/TermsAndConditions.vue';
import * as mutationTypes from '@/store/types/mutations';

export default {
  name: 'event-form-field',
  $_veeValidate: {
    value() {
      return this.input;
    },
  },
  components: {
    AddressField,
    PhoneField,
  },
  computed: {
    field() {
      return this.value;
    },
  },
  data() {
    return {
      multi: [],
      input: null,
    };
  },
  methods: {
    inputHandler(val) {
      this.input = val;
      if (this.field.type === 'select' && this.field.select_type === 'check') {
        this.$emit('input', val.join(', '));
      } else {
        this.$emit('input', val);
      }
    },
    openWaiver(waiver) {
      this.$store.commit(mutationTypes.SET_WAIVER, waiver);
      this.$modal.open({
        parent: this,
        component: WaiverModal,
        hasModalCard: true,
      });
    },
    optionInputHandler(key) {
      const option = _.find(this.field.options, { key });
      this.inputHandler(option.label);
    },
  },
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
    },
    message: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.event-form-field {
  &.checkbox-label {
    margin-bottom: 0.5rem;
  }
  &.is-danger {
    // label {
    //   color: $danger;
    // }
    input {
      border-color: $danger;
    }
  }
  label {
    color: $grey;
  }
  .checkbox {
    .control-label {
      font-size: 0.9rem;
    }
  }
  .select-checkboxes {
    margin-top: 0.75rem;
    .field:not(:last-child) {
      margin-bottom: 0.65rem;
    }
  }
}
</style>
